<template>
  <section>
    <v-row justify="center">
      <v-col cols="12">
        <v-progress-linear
          v-model="value"
          :size="70"
          width="7"
          :color="color"
          :indeterminate="error"
        ></v-progress-linear>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <h3>Your invoice file is being processed.</h3>
      </v-col>
      <v-col cols="12" class="text-center">
        <h4>Step: {{messageStep}}</h4>
      </v-col>
    </v-row>


  </section>



</template>

<script>
import axios from 'axios'

export default {
  name: "InvoiceUploadChecker",
  props: {
    active: Boolean,
    jobId: String,
  },
  data() {
    return {
      fileChecked: false,
      color: 'blue darken-1',
      value: 0,
      error: false,
      messageStep: '',
      requestLoop: null,
    }
  },
  methods: {
    fileUpload() {
      if (!this.fileChecked && this.active) {
        axios.get(process.env.API_URL + '/invoices/' + this.jobId + '/status')
          .then((response) => {
            if (response.data.status === 1) {
              this.value = 33;
              this.messageStep = 'Your invoices has been queued';
            }
            if (response.data.status === 2) {
              this.value = 66;
              this.messageStep = 'Your invoices is being processed';
              if (response.data.message !== null) {
                this.messageStep = response.data.message;
              }
            }
            if (response.data.status === 3) {
              this.value = 100;
              this.messageStep = 'Your invoices has been checked';
              this.fileChecked = true;
              clearInterval(this.requestLoop);
              console.log("final check and get the summary " + response.data.status);
              // Event emitted when API returns a code saying that file has been checked.
              this.$emit('file-checked')
            }
            if (response.data.status === 4) {
              this.value = 0;
              this.error = true;
              this.color = 'red';
              this.messageStep = 'An error has occurred when uploading your invoice'
              clearInterval(this.requestLoop);
            }
          })
          .catch((response) => {
            console.log(response);
            this.$emit('alert', 'ERROR ' + response.response.data.error);
            clearInterval(this.requestLoop);
          })
      }
    },

    checkLoop() {
      this.requestLoop = setInterval(this.fileUpload, 1500);
    }
  },
  mounted() {
    this.checkLoop();
  }

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/util/Invoices/InvoiceUploadChecker.vue